
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 4.75A3.25 3.25 0 008.75 8v1.25h6.5V8A3.25 3.25 0 0012 4.75zM7.25 8v1.25H7A2.75 2.75 0 004.25 12v6A2.75 2.75 0 007 20.75h10A2.75 2.75 0 0019.75 18v-6A2.75 2.75 0 0017 9.25h-.25V8a4.75 4.75 0 10-9.5 0zM7 10.75h10c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25v-6c0-.69.56-1.25 1.25-1.25zm5 6a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"}})])
          )
        }
      }
    